// extracted by mini-css-extract-plugin
export default {"formHeading":"SI-z","form":"TI-z","submitBtn":"UI-z","disabled":"VI-z","input":"WI-z","error":"XI-z","submitMsg":"YI-z","signIn":"ZI-z"};